import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAppSelector } from '~/store';
import { selectLogin } from '~/store/auth/login/selectors';

export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const { signed } = useAppSelector(selectLogin);
  const location = useLocation();
  if (!signed) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }
  return <>{children}</>;
}

export function AuthOnlyRoute({ children }: { children: ReactNode }) {
  const { signed } = useAppSelector(selectLogin);
  if (signed) {
    return <Navigate to="/app/home" replace />;
  }
  return <>{children}</>;
}
